import React from "../../_snowpack/pkg/react.js";
import EmailListController from "../components/controllers/EmailListController.js";
const EmailListPage = () => /* @__PURE__ */ React.createElement(EmailListController, null);
export default EmailListPage;
